const english = {
  "ui.language": "Language",
  "ui.painting": "painting…",
  "ui.close": "Close",
  "ui.hiderCanvas": "Art room with your movable chameleon — walk it to a spot, then paint and hide.",
  "ui.seekerCanvas": "Move through the art room and inspect the circle in front of your chameleon.",
  "ui.reportReason": "Report reason",
  "ui.qrCode": "QR code linking to this hide",
  "hider.painted": "painted",
  "brand.name": "Painterly Chameleon",
  "brand.home": "Painterly Chameleon home",
  "support.nextRoom": "support the next room",
  "support.knowMore": "know more?",
  "store.unlockAll": "Unlock all rooms to hide in", "store.seekFree": "Seeking is always free", "store.unlockBlurb": "One-time {price}. Seeking a friend's room is always free.", "store.payContinue": "Continue to Stripe", "store.notNow": "Not now",
  "store.comingSoon": "The full collection unlocks soon — checkout isn't live yet.",
  "store.unlockFailed": "Could not unlock. Please try again.",
  "store.checkoutFailed": "Could not start checkout. Please try again.",
  "game.hideAndSeek": "hide-and-seek!",
  "share.title": "Find my Painterly Chameleon",
  "share.text": "Can you spot where I hid it?",
  "house.vanGogh": "Van Gogh",
  "house.monet": "Monet",
  "house.outdoor": "Outdoor",
  "house.colorRebirth": "Color Rebirth",
  "house.luminousTide": "Starlit Tide",
  "house.unfinishedMorning": "Unfinished Morning",
  "house.vanGoghFull": "Van Gogh House",
  "house.monetFull": "Monet Garden House",
  "house.outdoorFull": "Outdoor Masters Journey",
  "house.colorRebirthFull": "The World Remembers Color",
  "house.luminousTideFull": "The Tide Dreams in Starlight",
  "house.unfinishedMorningFull": "The Unfinished Morning",
  "house.liveGallery": "Live Gallery",
  "house.liveGalleryFull": "The Live Gallery",
  "hider.notPainted": "unpainted",
  "hider.ready": "ready",
  "hider.closeLook": "close look",
  "hider.initialHint": "Paint your chameleon first.",
  "hider.paint": "paint",
  "hider.texture": "mix room",
  "hider.publish": "hide",
  "hider.publicTitle": "share",
  "hider.nextRoom": "Another room—keep wandering or hide here.",
  "hider.walkFinal": "Looking good. Pick a hiding spot.",
  "hider.shuffled": "Fresh paint. Your chameleon stayed put.",
  "hider.security": "quick security check…",
  "hider.compressing": "squishing the paint…",
  "hider.linking": "making your link…",
  "hider.newRoomName": "new room name",
  "hider.guideLine1": "Move and paint your chameleon,",
  "hider.guideLine2": "then hide it. Share with a friend—",
  "hider.guideLine3": "let them find it!",
  "hider.publishFailed": "That one wouldn’t publish",
  "seeker.start": "start",
  "seeker.status": "Inspect the circle.",
  "seeker.keepCircle": "Keep looking.",
  "seeker.giveUp": "show me",
  "seeker.inspect": "close look",
  "seeker.notThere": "not there · {count}",
  "seeker.gotIt": "got it!",
  "seeker.thereIn": "There it is—in {room}.",
  "seeker.nice": "Nice! {time}.",
  "seeker.myTurn": "my turn →",
  "seeker.timeUp": "time’s up!",
  "seeker.outOfLooks": "out of looks!",
  "seeker.backToExplore": "back to lobby →",
  "seeker.readyLine1": "Your friend painted and hid",
  "seeker.readyLine2": "their chameleon.",
  "seeker.readyCall": "Your turn to find it!",
  "seeker.legacy": "This hide came from an older playtest. Ask your friend to make a fresh link.",
  "seeker.expired": "This challenge has expired",
  "seeker.unavailable": "Challenge unavailable",
  "report.summary": "report",
  "report.link": "not ok? report",
  "report.notOkay": "not okay",
  "report.broken": "broken",
  "report.other": "other",
  "report.checking": "quick security check…",
  "report.sending": "sending that quietly…",
  "report.hidden": "Thanks. It’s off the Lobby now; the friend link still works.",
  "report.saved": "Thanks. We saved the report.",
  "report.failed": "Couldn’t send that yet. {message}",
  "report.already": "Thanks—your report was already sent.",
  "explore.cta": "Lobby",
  "explore.loading": "loading…",
  "explore.loaded": "",
  "explore.loadError": "try again",
  "explore.trickyTitle": "sneaky",
  "explore.freshTitle": "new",
  "explore.surpriseTitle": "random",
  "explore.trickyEmpty": "none yet",
  "explore.freshEmpty": "none yet",
  "explore.surpriseEmpty": "none yet",
  "explore.tryChallenge": "seek →",
  "explore.refresh": "refresh",
  "explore.noLooks": "new",
  "explore.looks": "{count} played",
  "explore.goneIn": "{time} left",
  "explore.hideHere": "hide here →",
  "explore.searchPlaceholder": "find a room name",
  "explore.searchClear": "clear search",
  "explore.searching": "looking…",
  "explore.searchEmpty": "no room found",
  "manage.link": "send this to your seekers",
  "manage.copy": "copy link",
  "manage.copied": "copied",
  "manage.share": "send it",
  "manage.shareCta": "challenge a friend",
  "manage.foundShot": "a seeker found it here",
  "manage.seekers": "peeked",
  "manage.found": "found it",
  "manage.average": "avg time",
  "manage.refresh": "check the results",
  "manage.unlist": "remove from lobby",
  "manage.delete": "delete this hide",
  "manage.createAnother": "hide another one →",
  "manage.expiry": "{visibility} · {time} left",
  "manage.visibilityLobby": "Lobby",
  "manage.visibilityPrivate": "private",
  "manage.listingFailed": "Could not change the lobby listing",
  "manage.deleteConfirm": "Delete this hide now? The shared link will stop working.",
  "manage.deleting": "Deleting…",
  "manage.deleteFailed": "Could not delete",
  "error.eyebrow": "hmm… this frame is empty",
  "error.title": "That hide isn’t here anymore.",
  "error.create": "make a new one →",
  "auth.signIn": "sign in",
  "auth.account": "account ✓",
  "auth.title": "one quick grown-up check",
  "auth.note": "A six-digit email code. No password.",
  "auth.email": "grown-up email",
  "auth.send": "send code",
  "auth.code": "six-digit code",
  "auth.verify": "let me in",
  "auth.again": "use another email",
  "auth.ready": "you’re in",
  "auth.continue": "keep painting",
  "auth.logout": "sign out",
  "auth.sending": "sending…",
  "auth.sent": "Check your email.",
  "auth.verifying": "checking…",
  "auth.devCode": "Local code: {code}",
  "account.rooms": "my rooms",
  "account.roomsLoading": "loading…",
  "account.roomsEmpty": "no rooms yet — go hide one!",
  "studio.eyebrow": "hider studio · take your time",
  "studio.leave": "← leave room",
  "studio.closeLabel": "return to the room",
  "studio.pose": "Pose", "pose.stand": "Stand", "pose.curl": "Curl", "pose.flat": "Flat",
  "studio.starterCamo": "Starter camouflage", "studio.on": "On", "studio.off": "Off",
  "studio.roomPalette": "Room palette", "studio.eyedropper": "Eyedropper", "studio.fullColor": "Full color",
  "studio.brush": "Brush", "studio.size": "Size", "studio.undo": "Undo stroke", "studio.clear": "Clear",
  "studio.stats": "flattened · compressed on publish · {count}/{max} undo",
  "studio.ready": "Ready", "studio.backToRoom": "Back to room", "studio.doneHide": "Done",
  "studio.roomSwatch": "Room", "studio.customSwatch": "Custom",
  "studio.label": "Painterly Chameleon paint studio",
  "studio.brushMode": "Chameleon brush mode",
  "studio.paintEnded": "Painting time ended — locking the current canvas",
  "studio.maskLoading": "Avatar mask is still loading — try again",
  "studio.tapPick": "Tap the avatar or visible room to pick a color",
  "studio.pickAny": "Pick any room or canvas color…",
  "studio.picked": "Picked {color}",
  "studio.systemPickerFallback": "System picker unavailable; tap the avatar or visible room",
  "studio.sampling": "Sampling room color…",
  "studio.noRoomPixel": "No room pixel there; tap the visible game or avatar",
  "studio.sampleFailed": "Room sampling failed; tap a painted color on the avatar",
  "studio.paletteFull": "Custom palette is full; using nearest room color {color}",
  "studio.canvasSampleFailed": "That canvas cannot be sampled; tap the visible room instead",
  "studio.pickedFromRoom": "Picked {color} from the room",
  "studio.transparentPixel": "That pixel is transparent; choose a painted part of the avatar",
  "brush.gaussian": "Gaussian", "brush.streak": "Streak", "brush.point": "Point",
  "brush.impasto": "Impasto", "brush.wash": "Wash", "brush.block": "Block",
  "brush.blueCurrent": "blue current", "brush.liquidColor": "liquid color",
  "brush.graphiteWhisper": "graphite whisper", "brush.firefly": "firefly",
  "brush.growth": "growth", "brush.colorLiquifySplash": "color liquify splash",
  "room.vanGogh.tip": "Borrow the room's direction, edge and value instead of filling the whole body one color.",
  "room.vanGogh.camo": "Van Gogh Camo",
  "room.vanGogh.camoHelp": "A removable cobalt, ochre and sunflower-colored starting layer.",
  "room.monet.tip": "Match light and temperature before hue. Neighboring translucent dabs mix at room scale.",
  "room.monet.camo": "Garden Light Camo",
  "room.monet.camoHelp": "A removable layer of teal, lavender, rose and pale-yellow reflected light.",
  "room.outdoor.tip": "Match the big light and dark shapes first, then let bold complementary color carry the camouflage.",
  "room.outdoor.camo": "Wild Outdoor Camo",
  "room.outdoor.camoHelp": "A removable layer of cobalt, orange, green and violet marks that follows the terrace and garden paths.",
  "room.colorRebirth.tip": "Start with value and soft edges. Let a tiny amount of color do the surprising work.",
  "room.colorRebirth.camo": "World Rewrite Camo",
  "room.colorRebirth.camoHelp": "Paper white, diluted blue-gray, charcoal and one small vermilion trace match the storm's structure.",
  "room.luminousTide.tip": "Match the dark-to-glow boundary first. A tiny cyan edge inside a big navy shape can disappear beautifully.",
  "room.luminousTide.camo": "Moon-Tide Camo",
  "room.luminousTide.camoHelp": "A removable layer of midnight stone, cyan tide-light, violet flowers and small gold reflections.",
  "room.unfinishedMorning.tip": "Treat blank paper as an active color: match the edge between finished pigment, erased construction and untouched canvas.",
  "room.unfinishedMorning.camo": "Unfinished Morning Camo",
  "room.unfinishedMorning.camoHelp": "Ivory paper, graphite structure and pale colored shadows leave deliberate incomplete gaps.",
  "room.liveGallery.tip": "Every room here belongs to a different painter — match the room you're hiding in, not one fixed style.",
  "room.liveGallery.camo": "Gallery Camo",
  "room.liveGallery.camoHelp": "A removable all-house layer of cobalt, tide-cyan, ochre, orange, green and violet marks.",
  "studio.paintTab": "paint", "studio.liveTab": "live brush", "studio.liveToggle": "Live",
  "studio.flow": "Flow", "studio.force": "Force", "studio.quiet": "quiet",
  "studio.liveStats": "{count}/{max} live marks",
  "studio.liveHelp": "paint motion on the chameleon · room force stays authored",
  "manage.roomNameLabel": "Room name:",
  "manage.searchRoomHint": "Search this room name in the Lobby to find it.",
  "live.badge": "live painting",
} as const;

export default english;
